<template>
  <v-autocomplete
    :loading="isLoading"
    :items="items"
    :search-input.sync="search"
    flat
    label="Locations"
    clearable
    item-text="name"
    item-value="id"
    v-model="model"
    :disabled="disabled"
    :rules="rules"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="indigo"
        class="headline font-weight-light white--text"
      >{{ item.name.charAt(0) }}</v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.name"></v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon>mdi-coin</v-icon>
      </v-list-item-action>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Search for a
          <strong>Location</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from "lodash";
import { mapActions } from 'vuex';
export default {
  name:"LocationAutocomplete",
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: {
    value: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed:{
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  watch: {
    search: {
      handler: _.debounce(function() {
        this.getLocations();
      }, 100)
    },
  },
  mounted: function() {
    this.getLocations();
  },
  methods: {
    ...mapActions("locations", {getLocationList:"list"}),
    getLocations() {
      this.isLoading = true;
      this.getLocationList({
          search: this.search,
          id: this.value
        })
        .then(data => {
          this.items = data.locations.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
